import { createI18n } from 'vue-i18n'
import type { SupportedLocale } from '@/stores/locale'
import ru from '@/locales/ru.yaml'
import en from '@/locales/en.yaml'
import vn from '@/locales/vn.yaml'

// Merge static pages translations
const ruMessages = { ...ru}
const enMessages = { ...en}
const vnMessages = { ...vn}

export type MessageSchema = typeof ruMessages

/**
 * Vue I18n instance
 * Composition API mode (legacy: false)
 * Поддерживаемые локали: ru, en, vn
 */
export const i18n = createI18n<[MessageSchema], SupportedLocale>({
  legacy: false,
  locale: 'ru',
  fallbackLocale: 'ru',
  messages: {
    ru: ruMessages,
    en: enMessages,
    vn: vnMessages,
  },
  globalInjection: true,
})

export default i18n
